import type {FileTreePayload} from '@github-ui/code-view-types'
import {mainQuery} from '@github-ui/react-core/future/main-query'

import {codeViewAppBuilder} from '../config/app-builder'

export const codeViewFileTreeLayoutRoute = codeViewAppBuilder.createQueryRouteConfig('codeViewFileTreeLayoutRoute', {
  path: '/:owner/:repo',
  queries: [
    mainQuery<FileTreePayload>({
      queryDeps: ({pathname}) => ({pathname: `${pathname}/_file_tree_layout`}),
    }),
  ],

  shouldRevalidate: ({currentParams, nextParams}) => {
    return currentParams.owner !== nextParams.owner || currentParams.repo !== nextParams.repo
  },
  tanStackRouterOptions: {
    // React Router's shouldRevalidate can't be automatically adapted for TanStack Router.
    // That's fine here: it only guards param changes, and TSR reloads on param change automatically.
    // This noop satisfies the TSR adapter's requirement that shouldRevalidate be manually reviewed.
    shouldReload: undefined,
  },
})
